import { Component, OnInit } from '@angular/core';
import { CommService } from "../../comm.service";
import { Router } from '@angular/router';
import {NgForm} from '@angular/forms';
import { NotifierService } from 'angular-notifier';

@Component({
  selector: 'app-lsa7s',
  templateUrl: './lsa7s.component.html',
  styleUrls: ['../../app.component.css']
})
export class LsaTydenniSkladComponent implements OnInit{

  today: number = Date.now();
  sklad=[];
  zaz_vyr=[];
  sssss=[];
  auditId:{"auditId":null};
  bozp=[];
  typ: number = 8;
  delkaBunky;
  provoz={"provozovna":""};
  provozovny=[];
  uzivatele=[];
  pnres={"id":null,};
  ProduktID;

  seconds=5;
  interval = null;

  itemclass;

  zaznamAudit={"typ":null, "auditId":null,"osoba":"", "operator":"", "pn":"", "komentar":"",  "question":null, "bod":"", "provoz":""};
  private notifier: NotifierService;

  constructor(private comm: CommService, private router:Router, notifier: NotifierService){this.notifier = notifier}


  ngOnInit() {
    this.itemclass = "none";
    this.zaznamAudit.question="";
    this.today = setInterval( () => {
           this.today = Date.now();
    }, 1000);
    this.getauditid();
    this.getuzivatele();
    this.getprovozovny();
    this.getLPA7s_sklad();
    this.getLPA7s_5s();
    this.getLPA7s_bozp();
  }

  getAuthUser() {
    return this.comm.getAuthUser()
  }

  getprovozovny(){
    this.comm.getProvozovny().subscribe(
      (response) => {
        this.provozovny=response.json();
        console.log(this.provozovny);
      },
      (error) => console.log(error));
      return this.provozovny;
  }

  getuzivatele(){
    this.comm.getUzivatele().subscribe(
      (response) => {
        this.uzivatele=response.json();
        console.log(this.uzivatele);
      },
      (error) => console.log(error));
      return this.uzivatele;
  }

  onSubmit(form:NgForm){
    this.delkaBunky=this.sklad.length+this.sssss.length+this.bozp.length;
    if ( form.value.provoz=='' ){this.notifier.notify('error', 'Vyplňte číslo operátora, PN a provozovnu!');}else{
          var i;
          var k=this.sklad[0].id;
          for (i = 0; i < this.delkaBunky; i++) {
          this.zaznamAudit.question=k;
          this.zaznamAudit.bod=form.value['q'+k];
          if (this.auditId[0].auditId!=null){this.zaznamAudit.auditId=this.auditId[0].auditId+1}else{this.zaznamAudit.auditId="0";};
          this.zaznamAudit.typ=this.typ;
          this.zaznamAudit.osoba=this.comm.getAuthUser().cislo;
          this.zaznamAudit.provoz=form.value.provoz;
          this.zaznamAudit.komentar=form.value.komentar;
          console.log(this.zaznamAudit);
          k=k+1;
          this.comm.postZaznamAudit(this.zaznamAudit).subscribe(
              (response) => console.log(response),
              (error) => console.log(error));
          }
          this.loading();
        }
  }

  getauditid(){
    this.comm.getAuditId().subscribe(
      //(response) => console.log(response),
      (response) => {
        this.auditId=response.json();
        console.log(this.auditId);
      },
      (error) => console.log(error));
      return this.auditId;
  }

  getLPA7s_sklad(){
    this.comm.getLpa('vsklad', 8).subscribe(
      //(response) => console.log(response),
      (response) => {
        this.sklad=response.json();
        console.log(this.sklad);
      },
      (error) => console.log(error));
      return this.sklad;
  }
  getLPA7s_5s(){
    this.comm.getLpa('5s', 8).subscribe(
      //(response) => console.log(response),
      (response) => {
        this.sssss=response.json();
        console.log(this.sssss);
      },
      (error) => console.log(error));
      return this.sssss;
  }
  getLPA7s_bozp(){
    this.comm.getLpa('bozp', 8).subscribe(
      //(response) => console.log(response),
      (response) => {
        this.bozp=response.json();
        console.log(this.bozp);
      },
      (error) => console.log(error));
      return this.bozp;
  }

  loading(){
    this.itemclass = "block";

    this.seconds=5;
    this.interval = setInterval(() => {
      if(this.seconds >=0) {
        this.seconds--;
        if(this.seconds===0){
          this.router.navigate(['/dashboard']);
        }
      } else {
                clearInterval(this.interval);
              }
    }, 1000);
  }

}
